<template>
  <div
    class="flex min-h-screen flex-col bg-background font-body text-on-background selection:bg-primary-container selection:text-on-primary-container"
  >
    <Header />

    <main
      class="flex flex-1 items-center justify-center px-4 pb-20 pt-28 md:pt-32"
    >
      <div class="mx-auto max-w-2xl text-center">
        <div class="mb-8">
          <h1
            class="font-headline text-7xl font-bold leading-none text-primary md:text-8xl lg:text-9xl"
          >
            404
          </h1>
        </div>

        <div class="mb-10 space-y-4">
          <h2
            class="font-headline text-3xl font-bold leading-tight tracking-tight text-on-background md:text-4xl lg:text-5xl"
          >
            Page not found
          </h2>
          <p
            class="font-body mx-auto max-w-xl text-lg leading-relaxed text-on-surface-variant md:text-xl"
          >
            The page you’re looking for doesn’t exist or has been moved. Let’s
            get you back on track.
          </p>
        </div>

        <div
          class="flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4"
        >
          <router-link
            to="/"
            class="hover-target inline-flex items-center justify-center gap-2 bg-primary px-8 py-3 font-body text-[11px] font-bold uppercase tracking-tighter text-on-primary transition-opacity hover:opacity-90 md:text-[12px]"
          >
            <span class="material-symbols-outlined text-base">home</span>
            Go home
          </router-link>
          <button
            type="button"
            class="hover-target inline-flex items-center justify-center gap-2 border border-outline-variant/40 bg-surface px-8 py-3 font-body text-[11px] font-bold uppercase tracking-tighter text-on-background transition-colors hover:border-primary hover:bg-primary/5 md:text-[12px]"
            @click="goBack"
          >
            <span class="material-symbols-outlined text-base">arrow_back</span>
            Go back
          </button>
        </div>

        <div class="mt-12 border-t border-outline-variant/20 pt-8">
          <p class="font-body mb-4 text-sm text-on-surface-variant">
            You might be looking for:
          </p>
          <div class="flex flex-wrap items-center justify-center gap-3">
            <router-link
              to="/"
              class="font-label text-sm font-bold uppercase tracking-widest text-primary transition-opacity hover:opacity-80"
            >
              Home
            </router-link>
            <span class="text-on-surface-variant/50" aria-hidden="true">·</span>
            <a
              href="mailto:info@brandintegrated.com"
              class="font-label text-sm font-bold uppercase tracking-widest text-primary transition-opacity hover:opacity-80"
            >
              Contact
            </a>
            <span class="text-on-surface-variant/50" aria-hidden="true">·</span>
            <a
              href="tel:+254204938268"
              class="font-label text-sm font-bold uppercase tracking-widest text-primary transition-opacity hover:opacity-80"
            >
              Call
            </a>
          </div>
        </div>
      </div>
    </main>

    <Footer />
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";

const router = useRouter();

const goBack = () => {
  if (window.history.length > 1) {
    router.go(-1);
  } else {
    router.push("/");
  }
};
</script>
